import ajax from './ajax'

export const BASE_API = '/tomato/api/v1'
//export const BASE_API = 'http://192.168.20.75:82/api/v1'

/****** 用户相关接口 ******/
// 登录
export const reqLogin = (username, password) => ajax(BASE_API + '/user/login', 'POST', {username, password})

// 注册
/**
 * 
 * @param {*} credentials object {username: '', password: '', confir_password: '', email: '', first_name: '', last_name: '', captcha: '', captcha_key: ''} 
 * @returns 
 */
export const reqRegister = (credentials) => ajax(BASE_API + '/user/register', 'POST', credentials)

// 用户激活
export const reqActivate = (uidb64, token) => ajax(BASE_API + `/user/activate/${uidb64}/${token}`)

// 用户退出
export const reqLogout = (token) => ajax(BASE_API + '/user/logout', 'POST', {refresh_token: token}, true)

// 刷新token
export const reqRefreshToken = () => ajax(BASE_API + '/token/refresh', 'GET', '', true)

// 密码重置Email
export const reqResetPwdEmail = (email) => ajax(BASE_API + '/user/resetpwdemail', 'POST', {email: email})

// 密码重置
/**
 * 
 * @param {*} credentials object {username: username, password: password, confirm_password: confirm_password, token: token}
 * @returns 
 */
export const reqResetPwd = (uidb64, token, credentials) => ajax(BASE_API + `/user/resetpwd/${uidb64}/${token}`, 'POST', credentials)

// 用户信息获取
export const reqAccountInfo = () => ajax(BASE_API + '/user/account', 'GET', '', true)

// 用户信息修改 传入的 user 参数是一个对象
export const reqAccountUpdate = (user) => ajax(BASE_API + '/user/account/edit', 'POST', user, true)

// 获取验证码
export const reqCaptcha = () => ajax(BASE_API + '/captcha', 'POST')



/****** Organism数据相关接口 ******/
export const reqOrganism = (organism = '') => ajax(BASE_API + `/species/${organism}/?format=json`)


/****** Analysis数据相关接口 ******/
export const reqAnalysis = (analysis = '') => ajax(BASE_API + `/analysis/${analysis}/?format=json`)


/****** Feature数据相关接口 ******/
export const reqFeatureInfo = (feature_id) => ajax(BASE_API + `/feature/${feature_id}`)


/****** Search相关接口 ******/
// search gene
export const reqSamplesInfo = (species) => ajax(BASE_API + `/retrive_samples_info/${species}`)

export const reqScaffoldInfo = (sample) => ajax(BASE_API + `/retrive_chr_info/${sample}`)

export const reqSearchSite = (data) => ajax(BASE_API + '/search/feature/', 'GET', data)

/**
 * 
 * @param {*} data const param = { species: species, dataset: dataset, feature_type: feature_type, seqid: loc_chr, feature_start: loc_start, feature_end: loc_end, feature_id: feature_name, text: keyword, page: page }
 * @returns 
 */
export const reqSearchFeature = (data) => ajax(BASE_API + '/search/feature/', 'GET', data)


/******  GWAS数据相关接口 ******/
// gwasviz
// 表型分类树形数据
export const reqGWAStraitData = (species) => ajax(BASE_API + `/gwasviz/retrive_trait_category/species/${species}`)

// GWAS Echarts图数据接口
export const reqGWASechartData = (species, trait) => ajax(BASE_API + `/gwasviz/retrive_echart/species/${species}/trait/${trait}`)

// GWAS默认展示配置参数 (包括默认表型, 默认区间, 默认染色体配置)
export const reqGWASdefaultConf = (GWAS_type, species) => ajax(BASE_API + `/gwasviz/retrive_default_conf/${GWAS_type}/${species}`)

// 获取trait的best region
export const reqBestRegion = (species, trait) => ajax(BASE_API + `/gwasviz/retrive_best_region/${species}/${trait}`, 'GET')

// search gwas
/**
 * 
 * @param {*} data { population, trait, variant_id, loc_chr, loc_start, loc_end, pvalue_start, pvalue_end }
 * @returns 
 */
export const reqSearchGwas = (data) => ajax(BASE_API + '/search/gwas/', 'GET', data)

// 根据用户选择的 population 获取 traits options
export const reqGwasTraitsInfo = (population) => ajax(BASE_API + `/gwas/traits/${population}`)

// 根据用户选择的 population 获取 chr options
export const reqGwasChrInfo = (population) => ajax(BASE_API + `/gwas/chr/${population}`)

// 根据用户选择的 population 和 trait 获取 variant ids options
export const reqGwasVariantsInfo = (population, trait) => ajax(BASE_API + `/gwas/variants/${population}/${trait}`)

// search egwas
export const reqSearcheGwas = (data) => ajax(BASE_API + '/search/egwas/', 'GET', data)
export const reqeGwasChrInfo = (genome) => ajax(BASE_API + `/egwas/chr/${genome}`)

// search snp&indel
/**
 * 
 * @param {*} data { population, ref_genome, variant_id, loc_chr, loc_start, loc_end, maf_start, maf_end }
 * @returns 
 */
export const reqSearchSnp = (data) => ajax(BASE_API + '/search/snp/', 'GET', data)

// 根据用户选择的 population 获取 ref options
export const reqSnpRefGenomeInfo = (population) => ajax(BASE_API + `/snp/ref_genome/${population}`)

// 根据用户选择的 population 获取 chr options
export const reqSnpChrInfo = (population) => ajax(BASE_API + `/snp/chr/${population}`)

// 根据用户选择的 population 和 ref genome 获取 variant ids options
export const reqSnpVariantIDsInfo = (population, ref_genome) => ajax(BASE_API + `/snp/variant_ids/${population}/${ref_genome}`)

// 根据用户选择的 population 和 ref genome 获取 variant ids options
export const reqSnpVariantTypesInfo = (population, ref_genome) => ajax(BASE_API + `/snp/variant_types/${population}/${ref_genome}`)

// search sv
/**
 * 
 * @param {*} data { population, ref_genome, variant_id, loc_chr, loc_start, loc_end, maf_start, maf_end }
 * @returns 
 */
 export const reqSearchSv = (data) => ajax(BASE_API + '/search/sv/', 'GET', data)

 // 根据用户选择的 population 获取 ref options
 export const reqSvRefGenomeInfo = (population) => ajax(BASE_API + `/sv/ref_genome/${population}`)
 
 // 根据用户选择的 population 获取 chr options
 export const reqSvChrInfo = (population) => ajax(BASE_API + `/sv/chr/${population}`)
 
 // 根据用户选择的 population 和 ref genome 获取 variant ids options
 export const reqSvVariantIDsInfo = (population, ref_genome) => ajax(BASE_API + `/sv/variant_ids/${population}/${ref_genome}`)
 
 // 根据用户选择的 population 和 ref genome 获取 variant ids options
 export const reqSvVariantTypesInfo = (population, ref_genome) => ajax(BASE_API + `/sv/variant_types/${population}/${ref_genome}`)


// search haplotype
export const reqHaplotypeChr = () => ajax(BASE_API + '/haplotype/chr')

export const reqSearchHaplotype = (data) => ajax(BASE_API + '/search/haplotype/', 'GET', data)


// search trait
export const reqRetriveTraits = (dataset) => ajax(BASE_API + `/search/trait/retrive_traits/${dataset}`)

export const reqSearchTrait = (dataset, query, traits) => ajax(BASE_API + `/search/trait/val/${dataset}/${query}/${traits}`)


// search crispr
export const reqSearchCrispr = (data) => ajax(BASE_API + '/search/crispr/', 'GET', data)

export const reqCrisprRefGenome = () => ajax(BASE_API + '/crispr/ref')

export const reqCrisprChr = (ref) => ajax(BASE_API + `/crispr/chr/${ref}`)

// Population data api
// 获取population pca echart图数据
export const reqPopulationPca = (pc1, pc2) => ajax(BASE_API + `/population/pca/${pc1}/${pc2}`)

// 获取population structure echart图数据
export const reqPopulationstructure = (k = 8) => ajax(BASE_API + `/population/structure/${k}`)


// Gene Expression api
export const reqPopExpSamples = () => ajax(BASE_API + '/pop_exp/samples')

export const reqRefExpSamples = (ref) => ajax(BASE_API + `/ref_exp/samples/${ref}`)


// tools - GeneIDs converter api
export const reqConvertIDs = (input_ids, dataset) => ajax(BASE_API + '/idconverter', 'POST', {input_ids: input_ids, dataset: dataset})

// snp primer pipline api
export const reqSnpPrimerPipline = (params) => ajax(BASE_API + '/snp_primer_pipline', 'POST', params)

// site help info api
export const reqSiteAbout = () => ajax(BASE_API + '/site/about/?format=json')

export const reqSiteNews = () => ajax(BASE_API + '/site/news/?format=json')

export const reqSiteContributors = () => ajax(BASE_API + '/site/contributors/?format=json')

export const reqSiteAcknowledgements = () => ajax(BASE_API + '/site/acknowledgements/?format=json')

export const reqSiteTutorial = () => ajax(BASE_API + '/site/tutorial/?format=json')

export const reqSiteDatasource = (id = '') => ajax(BASE_API + `/site/datasource/${id}/?format=json`)

export const reqSitePublications = () => ajax(BASE_API + '/site/publications/?format=json')

export const reqSiteAbbreviationsAnnotation = () => ajax(BASE_API + '/site/abbreviations_annotation/?format=json')


// sl5
export const reqSl5 = () => ajax(BASE_API + '/help/sl5.0/?format=json')
